import React, { ReactNode } from "react";
import { Header, Image, Grid } from "semantic-ui-react";
import darkLogo from "./apex-fintech-solutions.png";
import styles from "./styles.module.scss";

export interface Props {
  title: ReactNode;
}

export const AppHeader = ({ title }: Props) => (
  <div className={styles.header}>
    <Grid columns={2} padded relaxed>
      <Grid.Row style={{ backgroundColor: "#FFFFFF" }}>
        <Grid.Column width={7}>
          <Image src={darkLogo} alt="Apex Clearing" size="small" />
        </Grid.Column>
        <Grid.Column textAlign="left" width={9}>
          <div style={{ paddingTop: "20px" }}>
            <Header
              as="h2"
              className={`${styles.appTitle} test-id-app-header-title`}
            >
              {title}
            </Header>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);
